import { render, staticRenderFns } from "./commentForm.vue?vue&type=template&id=43eaf04f"
import script from "./commentForm.vue?vue&type=script&lang=js"
export * from "./commentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports